var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('PageLoading'):_c('div',{staticClass:"main-wrap about-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('q-img',{attrs:{"src":_vm.firstImage,"alt":"CFMA"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }